module.exports = {
  en: require('./en.json'),
  hi: require('./hi.json'),
  pt: require('./pt.json')
}